import React, { useEffect, useState ,useRef } from "react";
import Loader from "../Loader";
import { useNavigate, useParams ,useLocation } from "react-router-dom";
import TopbarSearch from "../Sidebar/TopbarSearch";
import { createOrder, searchStock, searchStocksApi, stockFmvData, trackViewContent } from "../../api/user";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import PageContainer from "../pages/PageContainer";
import BuyChart from "../../pages/BuyChart";
import GameSideBar from "./GameSideBar";
import $ from "jquery";


function truncateToDecimals(num, dec = 2) {
  const calcDec = Math.pow(10, dec);
  return Math.trunc(num * calcDec) / calcDec;
}

const BuySellFunction = (props) => {
  const game_id = props.game_id ?? null;
  const slug = props.slug ?? null;
const location = useLocation();
  const [stocksData, setStockData] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [search, setSearch] = useState("");
  let { symbol, id, ticker } = useParams();
  if(ticker && !isNaN(ticker)) {
    id = ticker;
  }
const [category, setCategory] = useState();
  const [activeTab, setActiveTab] = useState("limit");
  const [scButton, setScButton] = useState(false);
  const [trade, setTrade] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [positionType, setPositionType] = useState(2);
  const [StockPrice, setStockPrice] = useState("");
  const [limitPrice, setLimitPrice] = useState(0);
  const [price, setPrice] = useState(null);
  const [lossPrice, setLossPrice] = useState(0);
  const [apiCalled, setApiCalled] = useState(false);
  const [quotes, setQuotes] = useState(null);
  let storedTicker = localStorage.getItem("ticker");
  const editTrade = JSON.parse(localStorage.getItem("trade"));
  const isIdPresent = !!id; // This will be true if id is present, false otherwise
  console.log(isIdPresent, "isIdPresent");
  const isSymbolPresent = !!symbol; // This will be true if id is present, false otherwise
  const regex = /^-?\d+\.?\d{0,2}$/;
  const regexNum = /^\d*\.?\d*$/;
  let isHolding = localStorage.getItem("holding");
  isHolding = isHolding && isHolding === "true";
  const pathSegments2 = location.pathname.split("/");
  const shouldHideForm =
    pathSegments2[1] === "buysell" && (!pathSegments2[2] || /^\d+$/.test(pathSegments2[2])) ||
    pathSegments2[1] === "charts";

  useEffect(() => {

    const handleCustomProfileEvent = (event) => {

      if (event?.detail?.ticker )  {
        localStorage.removeItem("holding");
        setQuantity(0);
        localStorage.setItem("ticker", event?.detail?.ticker);
        // localStorage.setItem("category", category);
        fetchPost(event?.detail?.ticker, isHolding ? "hEvent" : "event");
        storedTicker = event?.detail?.ticker;
        return storedTicker;
      }
    };

    window.addEventListener("tickerEvent", handleCustomProfileEvent);

  }, [window.addEventListener, game_id]);


useEffect(() => {
  trackViewContent();
}, []);


  useEffect(() => {
    if (!id && symbol) {
      localStorage.setItem("ticker", symbol);
      // localStorage.setItem("category", category);

    } else if (!id && !symbol) {
      const storedTicker = localStorage.getItem("ticker");
      if (!storedTicker) {
        localStorage.setItem("ticker", "SPY");
    //    localStorage.setItem("category", 'Stocks');
      }
    }
  }, [symbol, id]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetchPost();
  }, [isIdPresent, symbol, isHolding]);
const searchRef = useRef("");
  const handleChange = (e) => {
     if(!shouldHideForm){
        setSearch(e.target.value.toUpperCase());
     }else{
      //old
      //setSearch(e);

      const value = e;
      searchRef.current = value;
      setSearch(value);
     }
  };

  const clearSearch = () => {
    search.current.value = "";
    setScButton(false);
  };

  const navigate = useNavigate();

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoadings(true);
  //   if (search !== "") {
  //     const res = await searchStocksApi(search.toUpperCase());

  //     if (res && res?.data?.data && res?.data?.data.length > 0) {
  //       localStorage.setItem("ticker", search);
  //       const myCustomEvent = new CustomEvent("tickerEvent", {
  //         detail: {
  //           ticker: res?.data?.data[0]?.stock_symbol,
  //         },
  //       });
  //       window.dispatchEvent(myCustomEvent);
  //       navigate(`/chartSearch/${res?.data?.data[0]?.stock_symbol}`);
  //       setStockData(res?.data?.data);
  //       setLoadings(false);
  //     } else {
  //       setLoadings(false);
  //     }
  //   } else {
  //     setLoadings(false);
  //   }
  // };
const handleSubmit = async (e) => {
  //e.preventDefault();
  setLoadings(true);
  if (search !== "") {
              const rawQuery = searchRef.current; // get and trim user input
          let formattedQuery = rawQuery;
            if (category === "Forex") {
            if (!formattedQuery.startsWith("C:")) {
              formattedQuery = `C:${formattedQuery}`;
            }
          } else if (category === "Crypto") {
            if (!formattedQuery.startsWith("X:")) {
              formattedQuery = `X:${formattedQuery}`;
            }
          }
        const query =formattedQuery;
    const res = await searchStocksApi({search:query.toUpperCase(),category: category,});

    if (res && res?.data?.data && res?.data?.data.length > 0) {
      localStorage.setItem("ticker", query);
      // localStorage.setItem("category", category);
      const myCustomEvent = new CustomEvent("tickerEvent", {
        detail: {
          ticker: res?.data?.data[0]?.stock_symbol,
        },
      });
      window.dispatchEvent(myCustomEvent);

      const stockSymbol = res?.data?.data[0]?.stock_symbol;


      // Check if the path ends with "/buysell"
      if (location.pathname.includes("/buysell")) {
        const basePath = location.pathname.split("/buysell")[0]; // Extract the path before "/buysell"
        navigate(`${basePath}/buysell`);
      } else {

        navigate(`/chartSearch/${stockSymbol}`);
      }

      setStockData(res?.data?.data);
      setLoadings(false);
    } else {
      // toast.error(`No stocks found for this keyword`);
      toast.error('No recent data available. This ticker has very low trading activity');
      setLoadings(false);
    }
  } else {
    setLoadings(false);
  }
};

  const fetchPost = async (tickervalue, eventType) => {
        //      alert(tickervalue);
        // alert(editTrade?.stock_symbol);
        // alert(localStorage.getItem("ticker")?.toUpperCase());
    setLoading(true);
    if (tickervalue) {
      localStorage.setItem("ticker", tickervalue);
      // localStorage.setItem("category", category);
    }
    if (isIdPresent || isHolding || eventType === "hEvent") {
      setLoading(true);
      try {
        // const response = await searchStock(
        //   tickervalue || (editTrade && editTrade.stock_symbol)
        //     ? editTrade.stock_symbol.toUpperCase()
        //     : localStorage.getItem("ticker") || "SPY"
        // );


          const searchString =
            (tickervalue && tickervalue) ||
            (editTrade?.stock_symbol) ||
            (localStorage.getItem("ticker")) ||
            "SPY";

          const category =
            searchString?.startsWith("C:") ? "Forex" :
            searchString?.startsWith("X:") ? "Crypto" :
            "Stocks";

          const response = await searchStock({
            search: searchString,
            category: category,
          });





        if (response?.data?.status === 200) {
          setLoading(false);
          setStocks(response?.data?.data);
          setStockPrice(
            response?.data?.data?.min?.c || response?.data?.data?.prevDay?.c
          );
          if (isHolding) {
            setLimitPrice(
              Number(response?.data?.data?.min?.c).toFixed(2) ||
                Number(response?.data?.data?.prevDay?.c).toFixed(2)
            );
            setLossPrice(
              Number(response?.data?.data?.min?.c).toFixed(2) ||
                Number(response?.data?.data?.prevDay?.c).toFixed(2)
            );
            setQuantity(editTrade?.order_quantity);
            if (editTrade.order_type === 2 || editTrade.order_type === 3) {
              // alert("BUY");
              setTrade(1);
            } else {
              // alert("SELL");
              setTrade(2);
            }
            setPositionType(editTrade.postion_type);

            //  setTrade(editTrade.order_type===3 || editTrade.order_type===2  ? 1 : 2);
          } else {
            setLoadings(false);
            setLimitPrice(editTrade.order_price);
            setLossPrice(editTrade.order_price);
            setTrade(
              editTrade.order_type === 3 || editTrade.order_type === 2 ? 2 : 1
            );
            setQuantity(editTrade?.order_quantity);
            setPositionType(editTrade.postion_type);
            if (editTrade.postion_type === 1) {
              setActiveTab("market");
            } else if (editTrade.postion_type === 2) {
              setActiveTab("limit");
            } else if (editTrade.postion_type === 3) {
              setActiveTab("stopLoss");
            }
          }
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error:", error);
      }
    } else {
      try {
        // alert(tickervalue);
        // alert(editTrade?.stock_symbol);
        // alert(localStorage.getItem("ticker")?.toUpperCase());
        setLoading(true);

        const searchString =
  (tickervalue && tickervalue) ||
  (editTrade?.stock_symbol) ||
  (localStorage.getItem("ticker")) ||
  "SPY";

const category =
  searchString?.startsWith("C:") ? "Forex" :
  searchString?.startsWith("X:") ? "Crypto" :
  "Stocks";

const response = await searchStock({
  search: searchString,
  category: category,
});


        if (response?.data?.status === 200) {
          console.log(response?.data?.data,'response tarun');
          setLoading(false);
          setPrice(null);
          setQuotes(null);
          setStocks(response?.data?.data);
          setStockPrice(
            response?.data?.data?.min?.c || response?.data?.data?.prevDay?.c
          );
          const val = truncateToDecimals(
            response?.data?.data?.min?.c || response?.data?.data?.prevDay?.c
          );
          setQuantity(0);
          setLimitPrice(Number(val).toFixed(2));
          setLossPrice(val || response?.data?.data?.prevDay?.c);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error("Error:", error);
      }
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    switch (tabName) {
      case "market":
        setPositionType(1);
        break;
      case "limit":
      case "stopLoss":
        setPositionType(2);
        break;
      default:
        setPositionType(2);
        break;
    }
  };

  const incrementQuantity = () => {
    setQuantity((prevQuantity) => roundToTwoDecimals(Number(prevQuantity) + 1));
  };

  const decrementQuantity = () => {
    if (quantity > 0) {
      setQuantity((prevQuantity) =>
        roundToTwoDecimals(Number(prevQuantity) - 1)
      );
    }
  };

  const roundToTwoDecimals = (number) => {
    return Math.round(number * 100) / 100;
  };

  const handleTradetype = (event) => {
    if (isHolding || isIdPresent) {
      event.preventDefault();
      return;
    }
    const selectedValue = event.target.value;
    let tradeValue;
    switch (selectedValue) {
      case "Buy":
        tradeValue = 1;
        break;
      case "Sell":
        tradeValue = 2;
        break;
      case "stopLoss":
        tradeValue = 2;
        break;
      default:
        tradeValue = 1; // Set default value if necessary
        break;
    }

    setTrade(tradeValue);
  };

  const handleSlider = async () => {
    setLoading(true);
    console.log(trade, "trade");
    if (!apiCalled) {
      setApiCalled(true);
      if (!stocks) {
        toast.error("Stocks data is missing");
        console.error("Error: Stocks data is missing");
        setApiCalled(false);
        setLoading(false);
        return;
      }
      if (!trade) {
        toast.error("Trade type is missing");
        console.error("Error: Trade type is missing");
        setApiCalled(false);
        setLoading(false);
        return;
      }
      if (
        quantity === undefined ||
        quantity === null ||
        quantity === "" ||
        quantity === 0 ||
        quantity === 0.0
      ) {
        toast.error("Quantity is missing");
        console.error("Error: Quantity is missing");
        setApiCalled(false);
        setLoading(false);
        return;
      }
      if (!positionType) {
        toast.error("Position type is missing");
        console.error("Error: Position type is missing");
        setApiCalled(false);
        setLoading(false);
        return;
      }

      const searchString = stocks?.ticker?.toUpperCase();

      const asset_type =
        searchString?.startsWith("C:") ? "forex" :
        searchString?.startsWith("X:") ? "crypto" :
        "stock";
      const data = {
        stock_symbol: stocks.ticker,
        asset_type: asset_type,
        order_type: trade,
        order_quantity: quantity,
        // order_price: $("#price_field").val(),
        order_price: quantity > 0 ? parseFloat($("#price_field").val()) / quantity : $("#price_field").val(),
        postion_type:
          activeTab === "stopLoss" ? 3 : activeTab === "limit" ? 2 : 1,
      };
      // If id is present, include id in the data
      if (isIdPresent) {
        data.id = id;
        // Send data here
      }

      // include game_id if not null
      if (game_id) {
        data.game_id = game_id;
      }
      try {
        const response = await createOrder(data);
        if (response?.data?.status === 200) {
          setTimeout(() => {}, 2000);
          toast.success(response.data.message);
          setLoading(false);
          // localStorage.removeItem("trade")
        } else {
          setLoading(false);
          toast.error(response.data.message);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error?.response?.data?.message);
        console.error("Error:", error?.message);
      } finally {
        setLoading(false);
        setApiCalled(false);
      }
    }
  };

  // const apiKey = process.env.REACT_APP_API_KEY;
    const apiKey = process.env.REACT_APP_API_KEY;
    //alert(apiKey);

  // useEffect(() => {
  //   const ws = new WebSocket("wss://business.polygon.io/stocks");
  //   const stockSymbol =
  //     (isIdPresent || isHolding) && editTrade
  //       ? editTrade.stock_symbol
  //       : isSymbolPresent
  //       ? symbol
  //       : storedTicker;

  //   ws.onopen = () => {
  //     ws.send(JSON.stringify({ action: "auth", params: apiKey }));
  //     ws.send(
  //       JSON.stringify({
  //         action: "subscribe",
  //         params: `FMV.${stockSymbol}`,
  //       })
  //     );
  //     ws.send(
  //       JSON.stringify({
  //         action: "subscribe",
  //         params: `Q.${stockSymbol}`,
  //       })
  //     );
  //     ws.send(
  //       JSON.stringify({
  //         action: "subscribe",
  //         params: `AM.${stockSymbol}`,
  //       })
  //     );
  //   };

  //   ws.onmessage = (event) => {
  //     const response = JSON.parse(event.data);

  //     response.forEach((msg) => {
  //       if (msg.ev === "FMV") {
  //         setPrice(msg.fmv);
  //       } else if (msg.ev === "Q") {
  //         setQuotes(msg);
  //       } else if (msg.ev === "AM") {
  //       }
  //     });
  //   };

  //   ws.onerror = (error) => {
  //     console.error("WebSocket Error: ", error);
  //   };

  //   return () => {
  //     ws.close();
  //   };
  // }, [apiKey, symbol, storedTicker]);



    // useEffect(() => {
    //   setPrice(stocksData?.ticker?.price);
    // }, [stocksData?.ticker?.ticker]);

    // useEffect(() => {
    //   if (!apiKey) {
    //     console.error("WebSocket Error: API key is missing.");
    //     return;
    //   }
    //     const stockSymbol =
    //       (isIdPresent || isHolding) && editTrade
    //         ? editTrade.stock_symbol
    //         : isSymbolPresent
    //         ? symbol
    //         : storedTicker;

    //     // Determine WebSocket path based on stockSymbol prefix
    //       let wsPath = "stocks";
    //       if (stockSymbol.startsWith("C:")) {
    //         wsPath = "forex";
    //       } else if (stockSymbol.startsWith("X:")) {
    //         wsPath = "crypto";
    //       }

    //   const ws = new WebSocket(`wss://business.polygon.io/${wsPath}?apiKey=${apiKey}`);

    //   console.log(`wss://business.polygon.io/${wsPath}?apiKey=${apiKey}`);


    //   ws.onopen = () => {
    //     console.log("WebSocket connected successfully");


    //     // Authenticate WebSocket connection
    //     ws.send(JSON.stringify({ action: "auth", params: apiKey }));

    //     // Subscribe to stock updates
    //     const subscriptions = [`FMV.${stockSymbol}`, `Q.${stockSymbol}`, `AM.${stockSymbol}`];
    //     subscriptions.forEach((sub) => {
    //       ws.send(JSON.stringify({ action: "subscribe", params: sub }));
    //       console.log(`Subscribed to: ${sub}`);
    //     });
    //   };

    // ws.onmessage = (event) => {
    //   try {
    //     const response = JSON.parse(event.data);
    //     console.log("WebSocket Message Received: 123", response);

    //     response.forEach((msg) => {
    //       if (msg.ev === "FMV") {
    //         setPrice(msg.fmv);
    //         const fmv = msg.fmv || stocks?.min?.c || StockPrice || 0; // fallback if needed
    //         const percent = Math.random() * (0.0005 - 0.0001) + 0.0001;
    //         const bid = fmv * (1 - percent);
    //         const ask = fmv * (1 + percent);

    //         setQuotes({
    //           ...msg,
    //           bid: bid.toFixed(2),
    //           ask: ask.toFixed(2),
    //         });
    //       } else if (msg.ev === "Q") {
    //       //  setQuotes(msg);
    //       } else if (msg.ev === "AM") {
    //         console.log("AM event received:", msg);
    //       } else if (msg.ev === "status") {
    //         // Handle status messages gracefully
    //         console.log(`Status update received: ${msg.status} - ${msg.message}`);
    //       } else {
    //         console.warn("Unhandled event received:", msg);
    //       }
    //     });
    //   } catch (error) {
    //     console.error("Error parsing WebSocket message:", error);
    //   }
    // };


    //   ws.onerror = (error) => {
    //     console.error("WebSocket Error:", error);
    //   };

    //   ws.onclose = (event) => {
    //     console.warn("WebSocket closed:", event);
    //   };

    //   // Cleanup WebSocket on component unmount
    //   return () => {
    //     if (ws.readyState === WebSocket.OPEN) {
    //       ws.close();
    //       console.log("WebSocket connection closed");
    //     }
    //   };
    // }, [apiKey, symbol, storedTicker]);

// Calculate stockSymbol outside useEffect
// Calculate stockSymbol outside useEffect

const stockSymbol =
  (isIdPresent || isHolding) && editTrade
    ? editTrade.stock_symbol
    : isSymbolPresent
    ? symbol
    : storedTicker;

const wsRef = useRef(null); // Track WebSocket instance

useEffect(() => {
  const fetchSymbolAndConnect = async () => {
    if (!apiKey) {
      console.error("WebSocket Error: API key is missing.");
      return;
    }

    // const query = stocks?.name;
    let category = "stocks";

    if (stockSymbol?.startsWith("C:")) {
      category = "forex";
    } else if (stockSymbol?.startsWith("X:")) {
      category = "crypto";
    }

    let resolvedSymbol = stockSymbol;
      const query = stockSymbol;

    if (category !== "stocks") {
      try {
        const apiResponse = await stockFmvData({ category, query });

        if (
          Array.isArray(apiResponse?.data) &&
          apiResponse.data[0]?.stock_symbol
        ) {
          resolvedSymbol = apiResponse.data[0].stock_symbol;
        } else {
          console.warn("FMV API did not return a valid stock_symbol.");
          return;
        }
      } catch (err) {
        console.error("Error fetching stock symbol for FMV subscription:", err);
        return;
      }
    }

    let wsPath = "stocks";
    if (resolvedSymbol?.startsWith("C:")) {
      wsPath = "forex";
    } else if (resolvedSymbol?.startsWith("X:")) {
      wsPath = "crypto";
    }

    // ✅ Close existing connection before creating a new one
    if (wsRef.current) {
      wsRef.current.close();
      console.log("Previous WebSocket connection closed.");
    }

    const ws = new WebSocket(`wss://business.polygon.io/${wsPath}?apiKey=${apiKey}`);
    wsRef.current = ws; // Store new WebSocket instance

    ws.onopen = () => {
      console.log("WebSocket connected successfully");

      ws.send(JSON.stringify({ action: "auth", params: apiKey }));
      const subscription = `FMV.${resolvedSymbol}`;
      ws.send(JSON.stringify({ action: "subscribe", params: subscription }));
      console.log(`Subscribed to: ${subscription}`);
    };

    ws.onmessage = (event) => {
      try {
        const response = JSON.parse(event.data);
        console.log("WebSocket Message Received:", response);

        if (Array.isArray(response)) {
          response.forEach((msg) => {
            if (msg.ev === "FMV") {
              setPrice(msg.fmv);
              const fmv = msg.fmv || stocks?.min?.c || StockPrice || 0;
              const percent = Math.random() * (0.0005 - 0.0001) + 0.0001;
              const bid = fmv * (1 - percent);
              const ask = fmv * (1 + percent);

              setQuotes({
                ...msg,
                bid: bid.toFixed(2),
                ask: ask.toFixed(2),
              });
            } else if (msg.ev === "status") {
              console.log(`Status update received: ${msg.status} - ${msg.message}`);
            }
          });
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    ws.onclose = (event) => {
      console.warn("WebSocket closed:", event);
    };
  };

  fetchSymbolAndConnect();

  return () => {
    if (wsRef.current) {
      wsRef.current.close();
      console.log("WebSocket cleaned up on unmount or change");
    }
  };
}, [apiKey, stockSymbol, stocks?.name]);


  const handlelimitChange = (e) => {
    const newValue = e.target.value;
    const regex = /^-?\d+\.?\d{0,2}$/;
    // Check if the new value matches the regex
    if (regex.test(newValue) || newValue === "") {
      setLimitPrice(newValue);
    } else {
      const regex = /^\d*\.?\d*$/;
      if (regex.test(newValue) || newValue === "") {
        const parts = newValue.split(".");

        if (parts[0] !== "") {
          const decimalPart = parts[1].slice(0, 2);
          const truncatedValue = `${parts[0]}.${decimalPart}`;
          setLimitPrice(truncatedValue);
        }
      }
    }
  };

  // const handleLossChange = (e) => {
  //   const newValue = e.target.value;

  //   // Check if the new value matches the regex
  //   if (regex.test(newValue)) {
  //     setLossPrice(newValue);
  //   } else {
  //     if (regexNum.test(newValue) || newValue === "") {
  //       const parts = newValue.split(".");
  //       if (parts[0] !== "") {
  //         const decimalPart = parts[1].slice(0, 2);
  //         const truncatedValue = `${parts[0]}.${decimalPart}`;
  //         setLossPrice(truncatedValue);
  //       }
  //     }
  //   }
  // };

  const [lastFocused, setLastFocused] = useState(null);

  // const handleFocus = (event) => {
  //   const inputField = event.target;
  //   if (lastFocused) {
  //     return; // Do not scroll if already focused on an input field (keyboard is assumed open)
  //   }
  //   setLastFocused(inputField);

  //   setTimeout(() => {
  //     const inputTop = inputField.getBoundingClientRect().top;
  //     const visibleScreenHeight = window.innerHeight;
  //     const desiredTopPosition =
  //       visibleScreenHeight - inputField.offsetHeight - 80; // Adjust the offset to your needs

  //     if (inputTop > visibleScreenHeight - inputField.offsetHeight - 80) {
  //       window.scrollTo({
  //         top: window.pageYOffset + inputTop - desiredTopPosition,
  //         behavior: "smooth",
  //       });
  //     }
  //   }, 500); // Adjust delay as needed to wait for iOS keyboard to appear
  // };

const handleFocus = (event) => {
  const inputField = event.target;

  // Ensure the page scrolls to the bottom
  setTimeout(() => {
    window.scrollTo({
      top: document.body.scrollHeight, // Scroll to the bottom of the page
      behavior: "smooth",
    });
  }, 300); // Delay to allow keyboard to appear
};


  const handleBlur = () => {
    setLastFocused(null); // Reset on blur, assuming the keyboard will close
  };
  const determineValue = () => {
    if (activeTab === "market") {
      return Number(price || stocks?.min?.c || StockPrice).toFixed(2);
    } else if (activeTab === "limit") {
      return limitPrice;
    } else {
      return lossPrice; // Assuming this is the fallback for other cases
    }
  };


  const handleCategory = (cat) => {
    setCategory(cat);
  }


  return (
    <PageContainer gamePage={game_id && true}>
      {isMobileView && (
        <TopbarSearch
          clearSearch={clearSearch}
          handleChange={handleChange}
          scButton={scButton}
          search={search}
          handleSubmit={handleSubmit}
          isMobileView={isMobileView}
          handleCategory={handleCategory}
        />
      )}
      {loadings ? <Loader /> : ""}

      {!loadings && slug && (
        <>
          <GameSideBar gamePage={game_id && true} activeMenu="buysell" slug={slug} />
        </>
      )}

      <div>
        {loading ? (
          <Loader />
        ) : (
          <div className="md:block rounded-2xl bg-white max-w-[60rem] overflow-hidden mx-auto">
            <div
              className={
                isMobileView
                  ? " bg-white px-2 py-4 rounded-lg"
                  : "px-12 py-2 bg-white rounded-lg"
              }
            >
              <h2 className="text-primaryColor font-bold text-center mb-4">
                {stocks?.ticker} <br />
                {stocks?.name}
              </h2>
              <div className="flex justify-between items-center">
                <div>
                  <div
                    className={`mr-2 ${
                      stocks?.todaysChange < 0
                        ? "text-[#D44735]"
                        : "text-greenXD"
                    }`}
                  >
                    {Number(price || stocks?.min?.c || StockPrice).toFixed(2)}
                  </div>
                  <div
                    className={`flex ${
                      stocks?.todaysChange < 0
                        ? "text-[#D44735]"
                        : "text-greenXD"
                    }`}
                  >
                    {stocks?.todaysChange ? stocks?.todaysChange.toFixed(2) : 0}{" "}
                    <p className="ml-2">
                      {stocks?.todaysChangePerc
                        ? stocks?.todaysChangePerc.toFixed(2)
                        : 0}
                    </p>
                    %
                  </div>
                </div>
                {/* <div className="p-4"> */}
                <div className="flex justify-between mb-4">
                  <div className="text-green-500 font-bold">
                    {quotes?.currentPrice || ""}
                  </div>
                  <div className="text-red-500 text-sm">
                    <span>{quotes?.change || ""}</span>{" "}
                    <span>{quotes?.percentChange || ""}</span>
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <div className="flex">
                    <div className="">
                      <div className="text-[#D44735] font-poppins mr-4">
                        Ask
                      </div>
                    </div>
                    <div className="text-[#D44735] font-bold col-span-1 mr-2">
                      {quotes?.as || ""}x
                    </div>
                    <div className="font-bold text-[#D44735] font-poppins col-span-2">
                      {quotes?.ask || "N/A"}
                    </div>
                  </div>

                  <div className="flex">
                    <div className="">
                      <div className="text-greenXD mr-4 font-poppins">Bid</div>
                    </div>
                    <div className="text-greenXD font-bold  col-span-1  mr-2">
                      {quotes?.bs || ""}x
                    </div>
                    <div className="font-bold text-greenXD font-poppins col-span-2">
                      {quotes?.bid || "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="overflow-hidden" style={{ overflow: "hidden" }}>
          <BuyChart
            symbol={
              (isIdPresent || isHolding) && editTrade
              ? editTrade.stock_symbol
              : isSymbolPresent
              ? symbol
              : storedTicker || localStorage.getItem("ticker")
            }
          />{" "}
        </div>

        <div className="md:block rounded-2xl bg-white max-w-full md:max-w-[60rem] overflow-hidden mx-auto">
          <div
            className={
              isMobileView
                ? "mb-6 bg-white py-4 px-2 rounded-lg"
                : "px-12 py-2 bg-white rounded-lg"
            }
          >
            <div className="mb-4">
              <p className="text-black mb-2">Trade Type</p>
              <select
                className="w-full h-10 rounded-lg text-center bg-primaryColor text-white test-class"
                value={trade === 2 ? "Sell" : "Buy"}
                onChange={(e) => handleTradetype(e)}
                readOnly={isHolding || isIdPresent}
                disabled={isHolding || isIdPresent}
                style={{
                  textAlignLast: "center",
                  backgroundColor:
                    isHolding || isIdPresent ? "#4c8184" : "#004c50",
                }}
              >
                <option className="bg-primaryColor text-white" value="Buy">
                  Buy
                </option>
                <option className="bg-primaryColor text-white" value="Sell">
                  Sell
                </option>
              </select>
            </div>
            <div className="flex justify-center mb-4">
              <div
                className={`cursor-pointer py-2 px-4 rounded-l-lg ${
                  activeTab === "limit"
                    ? "bg-primaryColor text-white"
                    : "bg-white text-primaryColor"
                } border border-primaryColor`}
                style={{ flex: 1 }}
                onClick={() => handleTabClick("limit")}
              >
                Limit
              </div>
              <div
                className={`cursor-pointer py-2 px-4 ${
                  activeTab === "market"
                    ? "bg-primaryColor text-white"
                    : "bg-white text-primaryColor"
                } border border-primaryColor`}
                style={{ flex: 1 }}
                onClick={() => handleTabClick("market")}
              >
                Market
              </div>
              <div
                className={`cursor-pointer py-2 px-4 rounded-r-lg ${
                  activeTab === "stopLoss"
                    ? "bg-primaryColor text-white"
                    : "bg-white text-primaryColor"
                } border border-primaryColor`}
                style={{ flex: 1 }}
                onClick={() => handleTabClick("stopLoss")}
              >
                Stop Loss
              </div>
            </div>
            {/* Quantity and Price */}
            <div className="grid grid-cols-3 items-center mb-4 gap-2">
              <div className="flex-1">
                <p className="text-black mb-2">Quantity</p>
                <div className="flex items-center px-4 py-2 bg-gray-300 rounded-lg">
                  <span onClick={decrementQuantity} className="cursor-pointer">
                    <FontAwesomeIcon icon={faMinus} />
                  </span>
                  <input
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    type="string"
                    value={quantity}
                    onChange={(e) => {
                      let val = e.target.value;

                      // Remove any non-numeric characters
                      val = val.replace(/\D/g, ""); // This regex removes all non-digit characters

                      setQuantity(val); // Update the state with the sanitized value
                    }}
                    className="flex-grow text-center bg-gray-300 border-none outline-none w-full"
                  />
                  <span onClick={incrementQuantity} className="cursor-pointer">
                    <FontAwesomeIcon icon={faPlus} />
                  </span>
                </div>
              </div>
              <div className="flex-1">
                <p className="text-black mb-2">Price</p>
                <div className="flex items-center px-4 py-2 bg-gray-300 rounded-lg">
                  <input
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    type="text"
                    // value={determineValue()}
                        value={determineValue()}
                    // onChange={
                    //   activeTab === "limit"
                    //     ? handlelimitChange
                    //     : handleLossChange
                    // }
                    onChange={(e) => {
                      const val = e.target.value;
                      const regex = /^\d*\.?\d{0,2}$/; // Regular expression to allow only up to two decimal places
                      if (regex.test(val)) {
                        activeTab === "limit"
                          ? setLimitPrice(val)
                          : setLossPrice(val);
                      }
                    }}
                    disabled={activeTab === "market"}
                    className="w-full text-center bg-gray-300 border-none outline-none"
                    id="base_price_field"
                  />
                </div>
              </div>
              <div className="flex-1">
                <p className="text-black mb-2">Total Price</p>
                <div className="flex items-center px-4 py-2 bg-gray-300 rounded-lg">
                  <input
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    type="text"
                    // value={determineValue()}
                        value={quantity > 0 ? (determineValue() * quantity).toFixed(2) : determineValue()}
                    // onChange={
                    //   activeTab === "limit"
                    //     ? handlelimitChange
                    //     : handleLossChange
                    // }
                    readOnly
                    disabled={activeTab === "market"}
                    className="w-full text-center bg-gray-300 border-none outline-none"
                    id="price_field"
                  />
                </div>
              </div>
            </div>

            {/* Button to Place Order */}
            <div className="relative mb-12">
              <button
                className="w-full h-12 rounded-full bg-primaryColor text-white font-semibold shadow-lg cursor-pointer hover:bg-primaryDark transition-colors"
                onClick={handleSlider}
                aria-label="Place Order"
              >
                Place Order
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default BuySellFunction;
